import { render } from "./CardEditActionField.vue?vue&type=template&id=55a2f833"
import script from "./CardEditActionField.vue?vue&type=script&lang=js"
export * from "./CardEditActionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__